var _rect, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconListArrow02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 21,
    height: 21,
    rx: 3.5,
    fill: "white",
    stroke: "#E2E2E2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_482_376",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 7,
    width: 14,
    height: 8
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 14.4349L18 7.5658L4 7.5658L4 14.4349L18 14.4349Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_482_376)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.351 14.2247L10.9153 9.41991L16.6637 14.1015C16.8107 14.2329 17.0014 14.3048 17.1985 14.3031C17.4088 14.3045 17.6111 14.2228 17.7613 14.0756C17.836 14.0035 17.8956 13.9172 17.9366 13.8218C17.9776 13.7263 17.9992 13.6237 18 13.5198C17.9979 13.414 17.9747 13.3096 17.932 13.2127C17.8892 13.1159 17.8276 13.0285 17.7508 12.9556L11.4396 7.77561C11.2896 7.63823 11.0931 7.56279 10.8897 7.56448C10.6863 7.56617 10.4911 7.64486 10.3434 7.78471L4.2436 13.1047C4.16665 13.1757 4.10524 13.2619 4.06323 13.3578C4.02123 13.4537 3.99954 13.5572 3.99954 13.6619C3.99954 13.7666 4.02123 13.8702 4.06323 13.9661C4.10524 14.062 4.16665 14.1481 4.2436 14.2191C4.39413 14.3578 4.59095 14.4353 4.79559 14.4366C5.00024 14.4379 5.19802 14.3628 5.3503 14.2261",
    fill: "#AAAAAA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconListArrow02);
export default __webpack_public_path__ + "static/media/icon-list-arrow-02.ab346170b71e88bd40c22f35be582776.svg";
export { ForwardRef as ReactComponent };